import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { environment } from '../../../../environments/environment';
import { SnackBarService } from '../../../shared/service/snack.bar.service';
import { PhotoZoomService } from "../../service/photo-zoom.service";

export interface DialogData {

}

@Component({
  selector: 'list-dialog',
  templateUrl: 'list-dialog.html',
})
export class ListDialog implements OnInit {
  project_id: string;
  project: any = [];
  virtualModel: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private snackBarService: SnackBarService,
    private photoZoomService: PhotoZoomService,
    public dialogRef: MatDialogRef<ListDialog>,
    @Inject(MAT_DIALOG_DATA) private data: any) {
  }


  ngOnInit() {
    this.project_id = this.data.project_id;
    this.virtualModel = this.data.virtual_model;
    // this.getData()
  }


  private getData() {
    let url = ``
    this.http.get(url).subscribe(data => {
      this.project = data;
    }, err => {
      this.dialogRef.close()
      this.snackBarService.show(err.error.Message);

    });
  }


  goTour(obj): void {
    this.dialogRef.close()
    let selectedUrl = obj.url
    let navigationExtras: NavigationExtras = {
      queryParams: { url: selectedUrl, project_id: this.project_id }
    };
    this.router.navigate(['/project-setting/tour'], navigationExtras);
  }
}